"use strict";

class PriceSchedulesIndexController {

    constructor($scope, $window, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSAwsService, SSUserService, SSAnalyticsService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;
        self.SSAnalyticsService= SSAnalyticsService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        self.UNIT_STATUS_DRAFT = SHOWSUITE.UNIT_STATUS_DRAFT;
        self.UNIT_STATUS_LISTED = SHOWSUITE.UNIT_STATUS_LISTED;
        self.UNIT_STATUS_RESERVED = SHOWSUITE.UNIT_STATUS_RESERVED;
        self.UNIT_STATUS_BOOKED = SHOWSUITE.UNIT_STATUS_BOOKED;
        self.UNIT_STATUS_SOLD = SHOWSUITE.UNIT_STATUS_SOLD;
        self.UNIT_STATUS_SPECIAL_RESERVED = SHOWSUITE.UNIT_STATUS_SPECIAL_RESERVED;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.user = self.SSUserService.getUser();
        if (!self.user) {
          self.SSUserService.showLoginModal();
        }

        self.getUnitSchedules();
    }

    getUnitSchedules(){
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/unit-price-schedules';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                self.unitSchedules = response.data.unit_price_schedules;
                self.users = response.data.users;

                jQuery.each(self.unitSchedules, function(index, schedule){
                    let user = self.users.find(x => x.id == schedule.created_by);
                    if(user){
                        schedule.user = user;
                    }
                    else{
                        schedule.user = null;
                    }
                });
            }

        });
    }

    getStatusName(status){
        const self = this;

        if(!status){
            return '--';
        }

        if(status == 10){
            return 'Pending';
        }
        else if(status == 20){
            return 'Successful';
        }
        else if(status == 30){
            return 'Failed';
        }
    }

    getStatusClass(status){
        const self = this;

        if(!status){
            return '';
        }

        if(status == 10){
            return 'text-primary';
        }
        else if(status == 20){
            return 'text-success';
        }
        else if(status == 30){
            return 'text-danger';
        }
    }

    getFormattedFloatValue(value){
        const self = this;

        if(!value){
            return value;
        }

        if(value > 0){
            return self.SSAppService.getFormattedFloatValue(value);
        }
        else{
            let _value = Math.abs(value);
            return '-' + self.SSAppService.getFormattedFloatValue(_value);
        }
    }

    createPriceSchedule(schedule_id){
        const self = this;

        let url = '';

        if(!schedule_id){
            url = '/developer/properties/' + self.property.named_id + '/create-schedule';
        }
        else{
            url = '/developer/properties/' + self.property.named_id + '/create-schedule/' + schedule_id;
        }

        self.$window.location.href = url;
    }

    deleteSchedule(schedule_id){
        const self = this;

        self.delete_schedule_id = schedule_id;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you would like to delete this price schedule?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function() {
                self._deleteSchedule();
            }
        );
    }

    _deleteSchedule(){
        const self = this;

        let url = 'sec/developer/properties/' + self.property.id + '/delete-unit-price-schedules/' + self.delete_schedule_id;

        // 'delete' methods are not working, so append 'delete' at end of url and call 'getAPI'
        url += '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
        // self.SSHttpService.deleteAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if(response.code == 404 && response.message){
                    self.SSAlertService.danger("Error!", response.message);
                }
                else{
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }
            self.SSAlertService.success('Success!', 'Price schedule deleted successfully.');
            self.unitSchedules = $.grep(self.unitSchedules, function(obj) {
                return obj.id != self.delete_schedule_id;
            });
        });
    }

    getFormattedDate(date){
        const self = this;

        try{
            if(date){
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            }
            else{
                return '--';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    getTime(date){
        const self = this;

        try{
            if(date){
                let time = self.UtctoLocal(date).split(' ')[1];

                // time format is: 00:00:00
                // required format: 00:00
                
                let _time = time.split(':');

                if(_time.length > 2){
                    if (_time[0] == "NaN")
                        return '';

                    return _time[0] + ":" + _time[1];
                }
                else{
                    if (_time == "NaN")
                        return '';

                    return _time;
                }
            }
            else{
                return '';
            }
        }
        catch(ex){
            console.log(ex);
        }
    }

    UtctoLocal(UTCDateString){
        const self = this;

        var convertdLocalTime = new Date(UTCDateString);

        var hourOffset = convertdLocalTime.getTimezoneOffset() / 60;

        convertdLocalTime.setHours(convertdLocalTime.getHours() -  hourOffset);

        var dateObj = new Date(convertdLocalTime);

        var _date = self.dateFormat(dateObj);

        return _date;
    }

    dateFormat(now) {
        const self = this;

        var year = "" + now.getFullYear();
        var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
        var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
        var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
        var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
        var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }

        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    }

    resetUnitPrices() {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Warning: Irreversible Action',
            'This will permanently reset ALL unit prices to $0 for every unit in this project. This action cannot be undone. Are you sure you want to continue?',
            self.SSConfirmationService.TYPE_DANGER,
            function() {
                self._resetUnitPrices();
            }
        );
    }

    _resetUnitPrices() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            let url = 'sec/developer/properties/' + self.property.id + '/reset-unit-prices';

            loading(true);
            self.SSHttpService.postAPIRequest(url, {}).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.SSAlertService.success('Success!', 'All unit prices have been reset to $0 successfully.');
            });
        });
    }

    exportPriceSchedule(){
        const self = this;

        let url = self.SSHttpService.getApiURL('sec/developer/properties/' + self.property.id + '/price-list-export?only_template=true');
        window.open(url, '_blank');

        self.SSAlertService.success("Success!", "Price List exported successfully");
    }

}

PriceSchedulesIndexController.$inject = ['$scope', '$window', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSAwsService', 'SSUserService','SSAnalyticsService','SSConfirmationService'];
app.controller('PriceSchedulesIndexController', PriceSchedulesIndexController);

